/**
 * Created by Wang on 2021/4/12.
 */

import tools from '../../tools'

export default {
    name: 'expoolPicture',
    watch: {
        //如果路由发生了变化，更新页面数据
        $route(to, from) {
            if (to.path !== from.path) {
                if (this.exercisePoolId != this.$route.params.exercisePoolId) {
                    this.exercisePoolId = this.$route.params.exercisePoolId;
                    this.jing = this.$route.params.jing;
                    this.Statu = this.$route.params.Statu
                    this.init();
                }
            }
        }
    },
    data() {
        return {
            exercisePoolId: this.$route.params.exercisePoolId,
            jing:this.$route.params.jing,
            Statu: this.$route.params.Statu,
            exercisePoolName: "",
            exercisePoolExcount: 0,
            exercisePoolSort: 0, //0 根据页码排序 1根据时间排序
            exercisePoolPictureStatus: false, //只看未识别
            exercisePoolPictureList: [],
            exercisePoolPictureList_Origin: [], //源数据，用于翻页时对比是否有更改，提示用户保存
            exercisePoolActiveIndex: 0, //当前项

            //没有数据
            isNothing: false,
            isRefresh: false, //刷新
            refreshTime: 0, //等待时间。5s过后未识别出图片，出现toast且恢复刷新按钮
            isNoImg: false, //如未扫描点击刷新，出现toast提示，2s消失

            //图片页码状态
            isEditorExercise: false, //是否可以开始录题，开始录入按钮需所有都标注后才激活
            reviewPictureTotalCount: 0, //图片总数量
            reviewPictureCount: 0, //已标注图片数量
            catalogPictureList: [], //目录页页码和状态
            answerPictureList: [], //答案页页码和状态
            exercisePictureList: [], //习题页页码和状态
            repeatPageCount: 0, //重复页数量

            //审核完成习题题号模态框
            isShowExPageReview: false,
            isHaveNoReviewExPage: false, //是否有未审核的，有的话都审核完毕弹模态框。没有的话不弹

            isReviewBtnLoading: false, //审核按钮小loading

            //收起和展开
            isOpen: true,
            //错误队列
            errorList:[],
            isshows:false

        }
    },
    created() {
        let that = this;
        that.init();
        this.$emit("header", false);
        this.$emit("footer", false);
    },
    mounted: function () {
        let _this = this;
        this.$nextTick(function () {
            HexSelector.init();
            _this.ShortcutKey();
        });
        this.geterrList();
    },
    updated: function () {

    },
    methods: {
        init: function () {
            let _this = this;
            _this.getExercisePool();
            _this.exercisePoolSort = 0;
            _this.exercisePoolPictureStatus = false;
            _this.exercisePoolActiveIndex = 0;
            _this.getPictureByExercisePool();
            _this.getPictureCountByExercisePool(function () {
                if (_this.reviewPictureCount == _this.reviewPictureTotalCount) {
                    _this.isHaveNoReviewExPage = false;
                } else {
                    _this.isHaveNoReviewExPage = true;
                }
            });
        },
        //获取题库
        getExercisePool: function () {
            let _this = this;
            tools.api('ExercisesPool.GetExercisePoolByIdAsync', {"exercisePoolId": _this.exercisePoolId}, (data) => {
                _this.exercisePoolName = data.ExercisePoolName;
                _this.exercisePoolExcount = data.ExerciseCount;
            });
        },
        reuploadpic:function(){
            let _this = this;
            // const loading = _this.$loading({
            //     lock: true});
             tools.putLoading();
            var i=-1;
            
            reload();
            function reload(){
                i++
                if(_this.errorList[i]==undefined){
                    _this.geterrList()
                   // loading.close();
                    tools.deleteLoading();
                    _this.isshows = false 
                    return false
                }
                $.ajax({ url: "https://exerciseocr.hexfuture.net/reRecognition", type:'get', data: {
                    "resourceid":_this.errorList[i].ResourceId,
                    "poolid":_this.exercisePoolId,
                }, success: function(data){
                    if(data){
                        reload()
                    }
                }});
            }
            
        },
        //获取错误列表
        geterrList:function(){
            let _this = this;
            tools.api('OCR.SearchExercisePoolOCRList', {"exercisePoolId":_this.exercisePoolId,'status':2}, (data) => {
                if(data.length<=0){
                    _this.errorList=false
                }else{
                    _this.errorList=data
                }
                
            });
        },
        //获取题库图片
        //排序方式: 页码排序按pictureType（图片类别）分类,再按照页码排序。时间排序不按pictureType分类，只看时间
        getPictureByExercisePool: function (callback) {
            let _this = this;
            _this.isNothing = false;
            tools.api('OCR.SearchResourceByExercisePoolAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "orderBy": _this.exercisePoolSort,
                "markStatus": _this.exercisePoolPictureStatus ? 0 : undefined  //0只看未识别,undefined是不传参
            }, (data) => {
                if (data && data.length > 0) {
                    _this.isNothing = false;
                    let PictureList = [];
                    for (let item of data) {
                        let PictureItem = {};
                        PictureItem.ocrDate = item.CreateTime ? item.CreateTime.replace("T", " ").split(".")[0] : item.CreateTime;
                        PictureItem.page = item.PageNumber;
                        PictureItem.picture = item.ResourceId;
                        PictureItem.pictureUrl = tools.ConvertResourceUrl(item.ResourceId);
                        PictureItem.pictureStatus = item.MarkStatus;
                        PictureItem.pictureType = item.ResourceType;
                        PictureList.push(PictureItem);
                    }
                    _this.exercisePoolPictureList = PictureList;
                    _this.exercisePoolPictureList_Origin = tools.cloneJson(PictureList);
                } else {
                    //没有数据，缺省页
                    _this.isNothing = true;
                }

                if (typeof callback == "function") {
                    callback();
                }
            });
        },
        //获取题库统计
        getPictureCountByExercisePool: function (callback) {
            let _this = this;

            _this.isEditorExercise = false;
            _this.reviewPictureTotalCount = 0;
            _this.reviewPictureCount = 0;
            _this.catalogPictureList = [];
            _this.answerPictureList = [];
            _this.exercisePictureList = [];
            _this.repeatPageCount = 0;

            tools.api('OCR.SearchResourceByExercisePoolAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "orderBy": 0,
            }, (data) => {
                if (data && data.length > 0) {
                    _this.reviewPictureTotalCount = data.length;
                    for (let item of data) {
                        let PictureItem = {};
                        PictureItem.page = item.PageNumber;
                        PictureItem.picture = item.ResourceId;
                        PictureItem.pictureStatus = item.MarkStatus;

                        if (item.ResourceType == 0) {
                            _this.catalogPictureList.push(PictureItem);
                        }
                        if (item.ResourceType == 1) {
                            _this.exercisePictureList.push(PictureItem);
                        }
                        if (item.ResourceType == 2) {
                            _this.answerPictureList.push(PictureItem);
                        }
                        if (item.MarkStatus >= 1) {
                            _this.reviewPictureCount++;
                        }
                    }

                    //开始录入按钮需所有都标注后才激活
                    if (_this.reviewPictureCount == _this.reviewPictureTotalCount) {
                        _this.isEditorExercise = true;
                    }

                    //判断习题页页码重复
                    for (let exPicture of _this.exercisePictureList) {
                        let temp = _this.exercisePictureList.filter(item => {
                            return item.page == exPicture.page;
                        })
                        if (temp && temp.length >= 2 && exPicture.page != 0) {
                            exPicture.isRepeatPage = true;
                            _this.repeatPageCount++;
                        } else {
                            exPicture.isRepeatPage = false;
                        }
                    }

                    if (typeof callback == "function") {
                        callback();
                    }
                }
            });
        },
        //刷新
        openRefresh: function () {
            this.isRefresh = true;
            let _this = this;
            _this.init();
            this.geterrList();
            let refreshTimeInterval = setInterval(function () {
                _this.refreshTime++
                if (_this.refreshTime == 5) {
                    clearInterval(refreshTimeInterval);
                    _this.refreshTime = 0;
                    _this.closeRefresh();
                }
            }, 1000)
        },
        closeRefresh: function () {
            let _this = this;
            _this.isRefresh = false;
            if (_this.isNothing) {
                //如果还是没有数据，显示提示
                _this.isNoImg = true;
                setTimeout(function () {
                    _this.isNoImg = false;
                }, 2000)
            } else {
                _this.isNoImg = false;
            }
        },

        //只看未识别
        changeExercisePoolPictureStatus: function () {
            this.exercisePoolPictureStatus = !this.exercisePoolPictureStatus;
            this.exercisePoolActiveIndex = 0;
            
            this.getPictureByExercisePool();
        },
        //排序方式
        changeExercisePoolSort: function (sort) {
            this.exercisePoolSort = sort;
            this.exercisePoolActiveIndex = 0;
            this.getPictureByExercisePool();
        },
        //上一张
        prevPicture: function () {
            let _this = this;
            try {
                let isSame = _this.comparisonDataChanges([_this.exercisePoolActiveIndex, _this.exercisePoolActiveIndex + 1]);
                if (!isSame) {
                    tools.alertconfim("是否确定修改？", "", function () {
                        _this.exPageReview("prev");
                    })
                    return false;
                }
            } catch (e) {
                console.log(e);
            }

            this.exercisePoolActiveIndex = this.exercisePoolActiveIndex - 2;
            if (this.exercisePoolActiveIndex < 0) {
                this.exercisePoolActiveIndex = 0;
            }
        },
        //下一张
        nextPicture: function () {
            let _this = this;
            try {
                let isSame = _this.comparisonDataChanges([_this.exercisePoolActiveIndex, _this.exercisePoolActiveIndex + 1]);
                if (!isSame) {
                    tools.alertconfim("是否确定修改？", "", function () {
                        _this.exPageReview();
                    })
                    return false;
                }
            } catch (e) {
                console.log(e);
            }

            this.exercisePoolActiveIndex = this.exercisePoolActiveIndex + 2;
            if (this.exercisePoolActiveIndex > this.exercisePoolPictureList.length - 1) {
                this.exercisePoolActiveIndex = this.exercisePoolPictureList.length - 1;
            }
        },
        //序号第几页
        indexPicture: function (picture) {
            let _this = this;
            _this.exercisePoolPictureList.forEach(function (item, index) {
                if (item.picture == picture) {
                    _this.exercisePoolActiveIndex = index;
                }
            })
        },
        //改变图片类型
        changePictureType: function (el, num) {
            el.pictureType = num;
        },
        //审核通过
        exPageReview: function (direction) {
            let _this = this;
            let json = [];
            tools.putLoading();
            _this.exercisePoolPictureList.forEach((item, index) => {
                if (index == _this.exercisePoolActiveIndex || index == _this.exercisePoolActiveIndex + 1) {
                    if (item.pictureStatus == 0) {
                        item.pictureStatus = 1;
                    }
                    json.push({
                        'resourceId': item.picture,
                        'pageNumber': item.page,
                        'resourceType': item.pictureType,
                        'markStatus': item.pictureStatus
                    })
                }
            })

            _this.exPageReviewCommon(json, function () {
                //如果有未标注的，找第一个未标注的(因为未标注的审核后，会变成已标注的，index直接往下会跳页 )
                let noStatusList = _this.exercisePoolPictureList.filter(function (item) {
                    return item.pictureStatus == 0;
                })

                if (noStatusList && noStatusList.length > 0) {
                    let picture = noStatusList[0].picture;
                    _this.exercisePoolPictureList.forEach(function (item, index) {
                        if (item.picture == picture) {
                            _this.exercisePoolActiveIndex = index;
                        }
                    })
                } else {
                    if (direction && direction == "prev") {
                        _this.prevPicture();
                    } else {
                        _this.nextPicture();
                    }
                }

                tools.deleteLoading();
            })
        },
        exPageReviewCommon: function (json, callback) {
            let _this = this;

            _this.isReviewBtnLoading = true;
            tools.api('OCR.SaveResourceStatusAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "resourceList": json
            }, (data) => {
                _this.isReviewBtnLoading = false;
                //判断是否是最后一页
                let lastPage = false;
                if (_this.exercisePoolActiveIndex + 2 > _this.exercisePoolPictureList.length - 1) {
                    lastPage = true;
                }

                _this.getPictureByExercisePool(function () {
                    if (typeof callback == "function") {
                        callback();
                    }
                });
                _this.getPictureCountByExercisePool(function () {
                    //全都审核通过&&有未审核的，展示进度
                    if (_this.reviewPictureCount == _this.reviewPictureTotalCount && _this.isHaveNoReviewExPage) {
                        _this.showExPageReview();
                    }
                    //全部审核通过&&修改审核到最后一页，直接进入到目录页
                    if (_this.reviewPictureCount == _this.reviewPictureTotalCount && !_this.isHaveNoReviewExPage && lastPage) {
                        _this.gotoExercisePool();
                    }
                });
            });
        },
        //删除图片
        delPicture: function (resourceId, index) {
            let _this = this;
            let json = [{'resourceId': resourceId}];

            tools.alertconfim("请确认是否移除该页", '', function () {
                tools.api('OCR.RemoveResourceByExercisePoolAsync', {
                    "exercisePoolId": _this.exercisePoolId,
                    "resourceList": json
                }, (data) => {
                    _this.getPictureByExercisePool();
                    _this.getPictureCountByExercisePool();

                    //如果删除最后一个
                    if (index == _this.exercisePoolPictureList.length - 1) {
                        let lastCount = _this.exercisePoolPictureList.length - 2;
                        if (lastCount < 0) {
                            lastCount = 0;
                        }
                        _this.exercisePoolActiveIndex = lastCount;
                    }
                });
            });
        },

        //最后一个审核通过，展示进度
        showExPageReview: function () {
            this.isShowExPageReview = true;
        },
        closeExPageReview: function () {
            this.isShowExPageReview = false;
        },

        //对比数据改变(如已改变，则提示数据改变，需要保存修改)
        comparisonDataChanges: function (indexList) {
            let _this = this;
            let isSame = true; //默认相同为true
            for (let i = 0; i < indexList.length; i++) {
                let index = indexList[i];
                let item = _this.exercisePoolPictureList[index];
                let item_Origin = _this.exercisePoolPictureList_Origin[index];
                if (item.pictureType != item_Origin.pictureType || item.page != item_Origin.page) {
                    isSame = false;
                }
            }
            return isSame;
        },

        //单图模式
        showSingleImage: function (item, index) {
            tools.OpenHref("//" + window.location.host + "/#/ocr/expoolSinglePicture/" + this.exercisePoolId + "/" + index+"/"+this.jing+'/'+this.Statu, "expoolSinglePicture");
        },

        //去题库页
        gotoExercisePool: function () {
            tools.deleteCookie("ExpoolActiveChapterId" + this.exercisePoolId);
            //跳转ocr录入页
            this.$router.push("/ocr/expool/" + this.exercisePoolId+"/"+this.jing+'/'+this.Statu);
        },
        //返回列表页
        gotoExpoolList: function () {
            window.close();
        },

        //展开和收起
        changeOpen: function () {
            this.isOpen = !this.isOpen;
        },

        //快捷键设置
        ShortcutKey: function () {
            let _this = this;
            try {
                // 第一个Tab首次定位到左边的页码，再按一次Tab定位到右边页码，回车进入下一页
                // 键盘的左右键控制上一批下一批
                document.addEventListener("keydown", function (e) {
                    let key = e.which || e.keyCode;
                    if (key === 9) {
                        event.stopPropagation();
                        event.preventDefault();

                        console.log("Tab");
                        if ($("input")[0] == document.activeElement) {
                            $("input")[1].select();
                        } else {
                            $("input")[0].select();
                        }
                    }
                    if (key === 13) {
                        event.stopPropagation();
                        event.preventDefault();

                        console.log("Enter");
                        _this.exPageReview();
                    }
                    if (key === 37) {
                        event.stopPropagation();
                        event.preventDefault();

                        console.log("Left arrow");
                        _this.prevPicture();
                    }
                    if (key === 39) {
                        event.stopPropagation();
                        event.preventDefault();

                        console.log("Right arrow");
                        _this.nextPicture();
                    }
                });
            } catch (e) {
                console.log(e);
            }
        },
    }
}